<template>
  <div>
    <el-row class="tac">
      <el-col :span="4">
        <el-menu
          style="position: fixed"
          default-active="1"
          class="el-menu-vertical-demo"
          @open="handleOpen"
          @close="handleClose">
          <el-menu-item index="1">
            <a href="#overview">
              <i class="el-icon-location"></i>
              <span slot="title" class="span">QVERVIEW</span>
            </a>
          </el-menu-item>
          <el-menu-item index="2">
            <a href="#background">
              <i class="el-icon-menu"></i>
              <span slot="title" class="span">BACKGROUND</span>
            </a>
          </el-menu-item>
          <el-menu-item index="3">
            <a href="#services">
              <i class="el-icon-document"></i>
              <span slot="title" class="span">SERVICES</span>
            </a>
          </el-menu-item>
          <el-menu-item index="4">
            <a href="#presentation">
              <i class="el-icon-setting"></i>
              <span slot="title" class="span">PRESENTATION</span>
            </a>
          </el-menu-item>
        </el-menu>
      </el-col>
      <el-col :span="20" :offset="4">
        <div class="allpredict">
          <div class="overview" id="overview" style="padding: 8em 4em 4em 4em;">
            <div
              style="text-align: left !important;margin-left: auto !important;margin-right: auto !important;box-sizing: border-box;">
              <h2 style="color: #787878;
          font-size: 2em;
          letter-spacing: 2px;
          font-weight: 400;margin-top: 0;
          margin-bottom: 0.5rem;">Predict fusions using exon RNA-seq counts</h2>
              <p style="font-size: 18px;
          letter-spacing: 1px;
          color: #999;
          font-weight: 400;margin-top: 3rem !important;">
                This webpage is to present a method using exon RNA-seq counts (Without sequence data) of a pair
                of gene from
                multiple experiments to infer if there are fusions between them. In this webpage, we will provide
                background
                information, explain the process of model and show the performation and robustness of it.</p>
              <div style="margin-top: 48px">
                <el-button class="predictnow" type="danger"><a href="#services" style="color: #fff"><span
                  style="font-size: 20px;font-family: 'Source Sans Pro', sans-serif;">Predict now</span></a></el-button>
              </div>
            </div>
          </div>
          <div class="background" id="background">
            <div class="backinforsec" id="background">
              <h3 class="bititle">Background information</h3>
              <h4 class="gefus">
                <br>
                Gene fusion
              </h4>
              <div class="t1lay">
                <div class="t1lay2">
                  <a>
                    <img src="../assets/images/t1.png" alt="news image" class="gefusimg" @click="t1detail">
                  </a>
                </div>
              </div>
              <el-dialog
                :visible.sync="geneDialogVisible"
                width="70%"
                height="70%"
                center>
                <div class="popup" style="height: 650px;overflow: auto;">
                  <h3 class="w3_head mb-5" align="center">Here present "What is gene fusion":</h3>
                  <p class="mt-4">The reasons for fusion to occur are various:</p>
                  <img src="../assets/images/t1-1.png" alt="Popup Image" class="img-fluid">
                  <p class="mt-4">(wiki) A fusion gene is a hybrid gene formed from two previously independent genes. It
                    can occur as a result of translocation, interstitial deletion, or chromosomal inversion. Fusion
                    genes have been found to be prevalent in all main types of human neoplasia. The identification of
                    these fusion genes play a prominent role in being a diagnostic and prognostic marker.</p>
                  <img src="../assets/images/t1.png" alt="Popup Image" class="img-fluid">
                  <p class="mt-4">Briefly,gene fusion is two broken genes join to form a gene and transcribe correspond
                    RNA.Thus the junction of exons from two genes is detectable in RNA sequence.</p>
                </div>
              </el-dialog>

              <h4 class="fuspre">
                <br>
                Fusion prediction
              </h4>
              <div class="t2lay">
                <div class="t2lay2">
                  <a>
                    <img src="../assets/images/t2.png" alt="news image" class="fuspreimg" @click="t2detail">
                  </a>
                </div>
              </div>
              <el-dialog
                :visible.sync="fusionDialogVisible"
                width="70%"
                height="70%"
                center>
                <div class="popup" style="height: 650px;overflow: auto;">
                  <h3 class="w3_head mb-5" align="center">The importance of gene fusion prediction:</h3>
                  <img src="../assets/images/t2-1.jpeg" alt="Popup Image" class="img-fluid">
                  <p class="mt-4">Fusion genes is an important cause of cancer,and therefore a biomarker for cancer
                    diagnosis. Rapid and accurate identification and discovery of fusion genes can not only help to
                    study their role in cancer lesions, but also have an important impact on clinical judgment and
                    treatment of cancer, as many fusion genes can be used as therapeutic targets of targeted drugs.</p>
                  <h3 class="w3_head mb-5" align="center"><br>Here present existing common methods for predicting gene
                    fusion:</h3>
                  <img src="../assets/images/t2.png" alt="Popup Image" class="img-fluid">
                  <p class="mt-4">With the development of transcriptome sequencing (RNA-seq) technology, gene fusion
                    detection using transcriptome sequencing data has been very common,with various methods and
                    computational tools developed. Those methods align the transcripts to reference genome, then screen
                    out fusion genes by finding spaning reads which have parts located in different genes and split
                    reads covering the junction of the two genes. In the end, filter out the false-positive prediction
                    with strict standards.</p>
                </div>
              </el-dialog>

              <h4>
                <br>
                Use of LSTM neural network
              </h4>
              <div class="t3lay">
                <div class="t3lay2">
                  <a>
                    <img src="../assets/images/t3.jpeg" alt="news image" class="t3img" @click="t3detail">
                  </a>
                </div>
              </div>
              <el-dialog
                :visible.sync="LSTMDialogVisible"
                width="70%"
                height="70%"
                center>
                <div class="popup">
                  <h3 class="w3_head mb-5" align="center">How can we use machine learning,specificly LSTM to do fusion
                    prediction:</h3>
                  <img src="../assets/images/t3.jpeg" alt="Popup Image" class="img-fluid">
                  <p class="mt-4">(wiki) A recurrent neural network (RNN) is a class of artificial neural networks where
                    connections between nodes form a directed graph along a temporal sequence. This allows it to exhibit
                    temporal dynamic behavior. Derived from feedforward neural networks, RNNs can use their internal
                    state (memory) to process variable length sequences of inputs.</p>
                  <p class="mt-4">(wiki) Long short-term memory (LSTM) is an artificial recurrent neural network (RNN)
                    architecture used in the field of deep learning.</p>
                  <p class="mt-4"> The ordered exons of two genes in this problem can be easily related to RNN cells
                    that transfer data from one cell to the next.Thus,we use LSTM for fusion detection and the details
                    of our methods can be seen in the next section.</p>
                </div>
              </el-dialog>
            </div>
          </div>
          <div class="services" id="services">
            <div class="service2">
              <h3 class="pfwotm">Predict Fusion with our trained model</h3>
              <div class="pfwotm2">
                <div class="pfwotm3">
                  <div class="sevice-box">
                    <div class="icon">
                      <el-button class="button" type="primary" @click="s1detail" plain>
                        <i style="font-size: 40px;" class="el-icon-reading"></i>
                      </el-button>
                    </div>
                    <p>
                      <br>
                      &nbsp;&nbsp;&nbsp;&nbsp;Click here to see Training process.</p>
                  </div>
                  <el-dialog
                    :visible.sync="processDialogVisible"
                    width="70%"
                    height="70%"
                    center>
                    <div class="popup" style="height: 650px;overflow: auto;">
                      <h3 class="w3_head mb-5" align="center">Training process:</h3>
                      <img src="../assets/images/s1.png" alt="Popup Image" class="img-fluid">
                    </div>
                  </el-dialog>
                  <div class="sevice-box">
                    <div class="icon">
                      <el-button class="button" type="primary" @click="formatdetail" plain>
                        <i style="font-size: 40px;" class="el-icon-document"></i>
                      </el-button>
                    </div>
                    <p>
                      <br>
                      &nbsp;&nbsp;&nbsp;&nbsp;Click here to see upload format.</p>
                  </div>
                  <el-dialog
                    :visible.sync="formatDialogVisible"
                    width="70%"
                    height="70%"
                    center>
                    <div class="popup" style="height: 650px;overflow: auto;">
                      <h3 class="w3_head mb-5" align="center">Input format example with annotations:</h3>
                      <textarea data-dojo-attach-point="txtViewForm" id="input0" rows="20"
                                style="font-size: 15px; width: 100%;height: 100%" readonly="readonly">//standard input format with annotation
1
// type: when type=1,we evaluate whether there is fusion between every two genes in your file
// when type=2,we evaluate whether there is fusion between  0th gene and 1th gene, 2th gene and 3th gene,(i)th gene and (i+1)th gene
gene0
//line with only one 'word'(no space inside) is regarded as gene name thus a separator for data of different gene
1 3 2 4 5
3 6 7 2 8
//one line for each exon,in which data of each experiment is seperated by space
//The gene you use shouldn't have too many exons, less than 15 for the best.
//This is due to LSTM's input size.
//If you want to do prediction on genes with much more exons,you can adjust the code, and train a model yourself.
 //The code is on github:    https://github.com/faded53222/Predict-fusions-using-exon-counts
4 2 19 0.5 0
gene1
14 53 45 67 123 33 234 123
23 54 63 13 424 44 115 435
//the number of exons can differ in different genes
//the number of experiments can differ in exons from different genes,but should be same in the same gene
gene2
90 123 435 542 123 342 12231</textarea>
                      <h3 class="w3_head mb-5" align="center">Output format example with annotations:</h3>
                      <textarea data-dojo-attach-point="txtViewForm" id="output0" rows="20"
                                style="font-size: 15px; width: 100%;height: 100%" readonly="readonly">Most likely possible fusion pairs:
gene0	gene1	0.888
//Gene pairs with fusion possibility more than 0.7 are selected as predicted fusion pairs.
//The fusion possibility of other pairs are also shown below.
//The value is actually the model's output , whose range is [0,1].
Fusion possibility between all other pairs:
gene1	gene2	0.333
gene0	gene2	0.222

</textarea>
                    </div>
                  </el-dialog>
                  <div class="sevice-box">
                    <div class="icon">
                      <el-button class="button" type="primary" @click="uploaddetail" plain>
                        <i style="font-size: 40px;" class="el-icon-upload"></i>
                      </el-button>
                    </div>
                    <p>
                      <br>
                      &nbsp;&nbsp;&nbsp;&nbsp;Click here to upload.</p>
                  </div>
                  <el-dialog
                    :visible.sync="uploadDialogVisible"
                    width="70%"
                    height="70%"
                    center>
                    <div class="popup" align="center" style="height: 650px;overflow: auto;">
                      <h3 class="w3_head mb-5" align="center">Drag your file here to upload.</h3>
                      <!--                      <div id="holder"></div>-->
                      <el-upload
                        class="upload-demo"
                        drag
                        action="https://jsonplaceholder.typicode.com/posts/"
                      >
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                        <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500kb</div>
                      </el-upload>
                      <p align="center">
                        <input type="text" id="the" value="0.7">
                        <input type="button" id="button" value="re-select">
                      </p>
                      <progress id="prog" value="0" style="visibility:hidden"></progress>
                      <textarea data-dojo-attach-point="txtViewForm" id="d_show0" rows="20"
                                style="font-ize: 15px; width: 100%;height: 100%" readonly="readonly">Most likely possible fusion pairs:</textarea>
                      <textarea data-dojo-attach-point="txtViewForm" id="d_show1" rows="20"
                                style="font-ize: 15px; width: 100%;height: 100%" readonly="readonly">Fusion possiblity between all pairs:</textarea>
                    </div>
                  </el-dialog>
                </div>
              </div>
            </div>
          </div>
          <div class="presentation" id="presentation">
            <div class="pretitle">
              <h3 class="pretitleh3">Showcase：Predict fusions with TCGA exon counts.</h3>
            </div>
            <div class="prelay">
              <div class="prelay2">
                <div class="news_top">
                  <h4>Overview</h4>
                  <p class="newsp">The accuracy and precision of predicting fusions at common cases.</p>
                  <div class="sevice-box">
                    <div class="icon">
                      <el-button class="button" type="primary" @click="overviewdetail" plain>
                        <i style="font-size: 40px;" class="el-icon-view"></i>
                      </el-button>
                    </div>
                    <p>
                      <br>
                      &nbsp;&nbsp;&nbsp;&nbsp;Click here to see the detail.</p>
                  </div>
                  <el-dialog
                    :visible.sync="overviewDialogVisible"
                    width="70%"
                    height="70%"
                    center>
                    <div class="popup" style="height: 650px;overflow: auto;">
                      <p class="newsp" id="show0">How to generate the training dataset?<br>
                        We take the annotation for fusions and generate a "positive sample" for each pair of fusion
                        genes.<br>
                        Then we randomly choose genes which has already been used in "positive samples" to form
                        pairs.<br>
                        Those random pairs are ensured not to be in fusion pairs,thus are "negative samples".<br>
                        In detail,for each sample of gene pair,we calculate the correlation matrix, partial correlation
                        matrix and pearson p-value matrix.<br>
                        With those three matrixs as "X" and the fusion lable 1 or 0 as "Y", we generate a
                        data_loader.<br>
                        At last,we split the data_loader into 80% train_loader for training and 20% test_loader for
                        testing.<br>
                        <br>
                        As for the training process,we feed the matrixs into three different LSTM network,synthesize the
                        output of the last LSTM cells of<br>
                        three LSTM networks using a sequential layer including dropout layer, linear layer and Sigmoid
                        activation layer.<br>
                        The model's final output is a float number between [0,1],with which we can easily get the
                        MSELoss between it and label 0/1.<br>
                        After that,we back propagate loss to optimize the model.<br>
                        <br>
                        Using fusion annotations from FusionGDB ( https://ccsm.uth.edu/FusionGDB/ ),<br>
                        We trained a model and its performance on Test set is:<br>
                        "<br>
                        Accuracy on Test Set: 68.6777 %<br>
                        total: 3199 real=1,predict=1: 655 real=1,predict=0: 879 real=0,predict=1: 123 real=0,predict=0:
                        1542<br>
                        Precision on Test Set: 84.1902 %<br>
                        "<br>
                        Similarly,we trained a model using fusion annotations from ChimerSeq
                        (https://www.kobic.re.kr/chimerdb_mirror/) and have results as:<br>
                        "<br>
                        Accuracy on Test Set: 66.0667 %<br>
                        total: 3000 real=1,predict=1: 948 real=1,predict=0: 559 real=0,predict=1: 459 real=0,predict=0:
                        1034<br>
                        Precision on Test Set: 67.3774 %<br>
                        "<br>
                        As you can see,the results are not worthless as many sequence based methods are worse.</p>
                    </div>
                  </el-dialog>

                  <h4>Less false positive when increasing threshold</h4>
                  <p class="newsp">Increase the threshold of being recognized as fusion and there is a significant
                    precision
                    increase.</p>
                  <div class="sevice-box">
                    <div class="icon">
                      <el-button class="button" type="primary" @click="thresholddetail" plain>
                        <i style="font-size: 40px;" class="el-icon-view"></i>
                      </el-button>
                    </div>
                    <p>
                      <br>
                      &nbsp;&nbsp;&nbsp;&nbsp;Click here to see the detail.</p>
                  </div>
                  <el-dialog
                    :visible.sync="thresholdDialogVisible"
                    width="70%"
                    height="70%"
                    center>
                    <div class="popup" style="height: 650px;overflow: auto;">
                      <p class="newsp" id="show3">As illustrated before,the model's final output is a float number
                        between [0,1].<br>
                        In previous tests, we assume there is fusion when the output is above 0.5 and get precision
                        around 65%.<br>
                        To get lower false positive rate, we can increase the threshold of selecting fusions to
                        0.6/0.7/0.8/0.9.<br>
                        <br>
                        In the joint dataset .<br>
                        Accuracy on Test Set: 63.6296 %<br>
                        total: 9417 real=1,predict=1: 1863 real=1,predict=0: 2367 real=0,predict=1: 1058
                        real=0,predict=0: 4129<br>
                        Precision on Test Set: 63.7795 %<br>
                        Precision when above 0.6: 65.1246 % total num (positive and false positive) is 843<br>
                        Precision when above 0.7: 74.1021 % total num is 529<br>
                        Precision when above 0.8: 76.4463 % total num is 242<br>
                        Precision when above 0.9: 83.8710 % total num is 31<br>
                        <br>
                        We can see that,there is a clearly precision increase at higher threshold.</p>
                    </div>
                  </el-dialog>

                  <h4>Robustness with different database</h4>
                  <p class="newsp">Use model trained from one database to predict fusions of another database to see
                    whether
                    the model will work for different databases.</p>
                  <div class="sevice-box">
                    <div class="icon">
                      <el-button class="button" type="primary" @click="diffdetail" plain>
                        <i style="font-size: 40px;" class="el-icon-view"></i>
                      </el-button>
                    </div>
                    <p>
                      <br>
                      &nbsp;&nbsp;&nbsp;&nbsp;Click here to see the detail.</p>
                  </div>
                  <el-dialog
                    :visible.sync="diffDialogVisible"
                    width="70%"
                    height="70%"
                    center>
                    <div class="popup" style="height: 650px;overflow: auto;">
                      <p class="newsp" id="show1">Fusion annotations from different database may be generated by various
                        methods and can differ a lot.<br>
                        We test if the model trained with annotations from one database can be used to predict fusions
                        from annother database.<br>
                        Using fusion annotations from FusionGDB ( https://ccsm.uth.edu/FusionGDB/ ),<br>
                        We trained a model named "model0" and its performance on Test set is:<br>
                        "<br>
                        Accuracy on Test Set: 68.6777 %<br>
                        total: 3199 real=1,predict=1: 655 real=1,predict=0: 879 real=0,predict=1: 123 real=0,predict=0:
                        1542<br>
                        Precision on Test Set: 84.1902 %<br>
                        "<br>
                        Similarly,we trained a model named "model1" using fusion annotations from ChimerSeq
                        (https://www.kobic.re.kr/chimerdb_mirror/) and have results as:<br>
                        "<br>
                        Accuracy on Test Set: 66.0667 %<br>
                        total: 3000 real=1,predict=1: 948 real=1,predict=0: 559 real=0,predict=1: 459 real=0,predict=0:
                        1034<br>
                        Precision on Test Set: 67.3774 %<br>
                        "<br>
                        <br>
                        Then,we use model0 to predict the dataset generated with ChimerSeq (model1's training set).<br>
                        Results<br>
                        "<br>
                        Accuracy on Test Set: 52.7000 %<br>
                        total: 3000 real=1,predict=1: 196 real=1,predict=0: 1311 real=0,predict=1: 108 real=0,predict=0:
                        1385<br>
                        Precision on Test Set: 64.4737 %<br>
                        "<br>
                        <br>
                        While the results of predicting the dataset generated with FusionGDB (model2's training set)
                        using model1 is:<br>
                        "<br>
                        Accuracy on Test Set: 62.3007 %<br>
                        total: 3199 real=1,predict=1: 958 real=1,predict=0: 576 real=0,predict=1: 630 real=0,predict=0:
                        1035<br>
                        Precision on Test Set: 60.3275 %<br>
                        "<br>
                        <br>
                        We can clearly see that, the model is still "predictive" for predicting fusions from different
                        dataset.<br>
                        And the "characteristic" of model remains.<br>
                        For example "model0" have a strict standard for being predicted as fusion ( the truth label of
                        fusion and not fusion is 1:1 while (948+459):(559+1034) is lower. )<br>
                        So,when predicting another dataset whose signs of fusion are more ambiguous, it misses more
                        positive genes.( Accuracy:52.7000 % with predicted_1 : predicted_0 =(196+108):(1311+1385) )<br>
                        But as the standard is stricter,the precision is pretty high( 64.4737 % ), which is very
                        important.( false negative is much more acceptable than false positive in this case.)</p>
                    </div>
                  </el-dialog>
                  <h4>Robustness with less samples for each exon</h4>
                  <p class="newsp">For a model trained with 1218 samples for each exon,we reduce the samples to
                    50,100,200,500 to test if there is significant performance drop.</p>
                  <div class="sevice-box">
                    <div class="icon">
                      <el-button class="button" type="primary" @click="exondetail" plain>
                        <i style="font-size: 40px;" class="el-icon-view"></i>
                      </el-button>
                    </div>
                    <p>
                      <br>
                      &nbsp;&nbsp;&nbsp;&nbsp;Click here to see the detail.</p>
                  </div>
                  <el-dialog
                    :visible.sync="exonDialogVisible"
                    width="70%"
                    height="70%"
                    center>
                    <div class="popup" style="height: 650px;overflow: auto;">
                      <p class="newsp" id="show2">Using ChimerSeq fusion annotations (
                        https://www.kobic.re.kr/chimerdb_mirror/),<br>
                        we train the model with 1218 samples for each exon and predict fusions within two genes with
                        only 50,100,200,500 samples.<br>
                        The results are as follows:<br>
                        predict with all(1218) samples, accuracy:66.0667% precision: 67.3774%<br>
                        predict with 500 samples, accuracy: 64.7900% precision: 65.2067%<br>
                        predict with 200 samples, accuracy: 64.8750% precision: 65.1616%<br>
                        predict with 100 samples, accuracy: 63.2100% precision: 62.8252%<br>
                        predict with 50 samples, accuracy: 62.0650% precision: 60.6647%<br>
                        <br>
                        And there is annother thing worth mentioning, considering p value into learning model is
                        important for robustness.<br>
                        Here is the results using model whose only difference with our final model is not taking p value
                        into consideration:<br>
                        <br>
                        predict with all(1218) samples, accuracy:65.4250% precision: 68.4211%<br>
                        predict with 500 samples, accuracy: :66.5700% precision: 67.5902%<br>
                        predict with 200 samples, accuracy: 64.9400% precision: 63.7115%<br>
                        predict with 100 samples, accuracy: 62.9550% precision: 60.3448%<br>
                        predict with 50 samples, accuracy: 60.5450% precision: 57.2951%<br>
                        <br>
                        We can see that after considering p value, there is smaller accuracy and precision drop when
                        using less samples.</p>
                    </div>
                  </el-dialog>
                  <h4>Code linkage</h4>
                  <p class="newsp">For a model trained with 1218 samples for each exon,we reduce the samples to
                    50,100,200,500 to test if there is significant performance drop.</p>
                  <div class="sevice-box">
                    <div class="icon">
                      <a href="https://github.com/faded53222/Predict-fusions-using-exon-counts" target="_blank">
                        <el-button class="button" type="primary" href="" plain>
                          <i style="font-size: 40px;" class="el-icon-cpu"></i>
                        </el-button>
                      </a>
                    </div>
                    <p>
                      <br>
                      &nbsp;&nbsp;&nbsp;&nbsp;Click here to see the detail.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "deepfusion",
  data() {
    return {
      geneDialogVisible: false,
      fusionDialogVisible: false,
      LSTMDialogVisible: false,
      processDialogVisible: false,
      formatDialogVisible: false,
      uploadDialogVisible: false,
      overviewDialogVisible: false,
      thresholdDialogVisible: false,
      diffDialogVisible: false,
      exonDialogVisible: false,

    }
  },
  methods: {
    t1detail() {
      this.geneDialogVisible = !(this.geneDialogVisible)
    },
    t2detail() {
      this.fusionDialogVisible = !(this.fusionDialogVisible)
    },
    t3detail() {
      this.LSTMDialogVisible = !(this.LSTMDialogVisible)
    },
    s1detail() {
      this.processDialogVisible = !(this.processDialogVisible)
    },
    formatdetail() {
      this.formatDialogVisible = !(this.formatDialogVisible)
    },
    uploaddetail() {
      this.uploadDialogVisible = !(this.uploadDialogVisible)
    },
    overviewdetail() {
      this.overviewDialogVisible = !(this.overviewDialogVisible)
    },
    thresholddetail() {
      this.thresholdDialogVisible = !(this.thresholdDialogVisible)
    },
    diffdetail() {
      this.diffDialogVisible = !(this.diffDialogVisible)
    },
    exondetail() {
      this.exonDialogVisible = !(this.exonDialogVisible)
    }
  }
}
</script>

<style scoped>
.allpredict {
  margin: 0;
  font-family: 'Source Sans Pro', sans-serif;
  background: #fff;
}

.background {
  padding: 4em 4em;
  border-top: solid 2px #efefef;
  background: #f0f4f4;
}

.backinforsec {
  padding-top: 3rem !important;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}

.bititle {
  margin-bottom: 48px;
  font-weight: 400;
  color: #787878;
  font-size: 1.5em;
  letter-spacing: 0.075em;
  line-height: 1.35em;
}

.t1lay {
  text-align: center !important;
  margin-top: 3rem !important;
  display: flex;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
  box-sizing: border-box;
}

.t1lay2 {
  -webkit-box-flex: 0;
  flex: 0 0 50%;
  max-width: 50%;
  position: relative;
  width: 100%;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;
  box-sizing: border-box;
  display: block;
  text-align: center !important;
}

.gefusimg {
  border-radius: 5px;
  vertical-align: middle;
  border-style: none;
  max-width: 100%;
  height: auto;
  box-sizing: border-box;
}

.t2lay {
  text-align: center !important;
  margin-top: 3rem !important;
  display: flex;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
}

.t2lay2 {
  -webkit-box-flex: 0;
  flex: 0 0 50%;
  max-width: 50%;
  position: relative;
  width: 100%;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;
  display: block;
}

.fuspreimg {
  border-radius: 5px;
  max-width: 100%;
  height: auto;
  vertical-align: middle;
  border-style: none;
}

h4 {
  font-size: 1.5rem;
  margin-bottom: 0.5rem;
  font-family: inherit;
  font-weight: 500;
  line-height: 1.2;
  color: inherit;
  margin-top: 0;
  display: block;
  margin-block-start: 1.33em;
  margin-block-end: 1.33em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
}

.t3lay {
  text-align: center !important;
  margin-top: 3rem !important;
  display: flex;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
  box-sizing: border-box;
}

.t3lay2 {
  -webkit-box-flex: 0;
  flex: 0 0 50%;
  max-width: 50%;
  position: relative;
  width: 100%;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;
  box-sizing: border-box;
  display: block;
  text-align: center !important;
}

.t3img {
  border-radius: 5px;
  max-width: 100%;
  height: auto;
  vertical-align: middle;
  border-style: none;
  box-sizing: border-box;
}

.services {
  padding: 4em 4em;
  display: block;
  box-sizing: border-box;
}

.service2 {
  box-sizing: border-box;
  display: block;
}

.pfwotm {
  font-weight: 400;
  color: #787878;
  font-size: 1.5em;
  letter-spacing: 0.075em;
  line-height: 1.35em;
  margin-bottom: 3rem !important;
  font-family: inherit;
  margin-bottom: 0.5rem;
  box-sizing: border-box;
  display: block;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
}

.pfwotm2 {
  margin-top: 3rem !important;
  display: flex;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
  box-sizing: border-box;
}

.pfwotm3 {
  -webkit-box-flex: 0;
  flex: 0 0 50%;
  max-width: 50%;
}

.sevice-box {
  margin-bottom: 40px;
  padding: 20px 0;
  -webkit-transition: all 1s;
  display: flex !important;
  box-sizing: border-box;
}

.icon {
  box-sizing: border-box;
  display: block;
}

.button {
  width: 100px;
  height: 100px;
  color: #00a8e0;
  border-radius: 50%;
  line-height: 100px;
  text-align: center;
  font-size: 26px;
  border: solid 2px rgba(210, 215, 217, 0.75);
  -webkit-transition: all 1s;
  display: inline-block;
  font: normal normal normal 14px/1 FontAwesome;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  box-sizing: border-box;

}

p {
  margin: 0;
  color: #777;
  font-size: 16px;
  line-height: 1.8;
  letter-spacing: 1px;
  box-sizing: border-box;
  display: block;
  margin-block-start: 0px;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;

}

.presentation {
  padding: 4em 4em;
  background: #ffffff;
  border-top: solid 2px #efefef;
  box-sizing: border-box;
  display: block;
}

.pretitle {
  text-align: left !important;
  box-sizing: border-box;
  display: block;
}

.pretitleh3 {
  font-weight: 400;
  color: #787878;
  font-size: 1.5em;
  letter-spacing: 0.075em;
  line-height: 1.35em;
  margin-bottom: 3rem !important;
  font-family: inherit;
  margin-top: 0;
  box-sizing: border-box;
  display: block;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
}

.prelay {
  display: flex;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
}

.prelay2 {
  -webkit-box-flex: 0;
  flex: 0 0 50%;
  max-width: 50%;
  position: relative;
  width: 100%;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;
  box-sizing: border-box;
  display: block;
}

.news_top {
  padding-right: 5em;
  box-sizing: border-box;
  display: block;
}

.newsp {
  font-size: 16px;
  letter-spacing: 1px;
  color: #999;
  font-weight: 400;
  margin: 0;
  line-height: 1.8;
  box-sizing: border-box;
  display: block;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
}

img {
  border-radius: 5px;
  max-width: 100%;
  height: auto;
  vertical-align: middle;
  border-style: none;
  box-sizing: border-box;
}

a {
  text-decoration: none;
  outline: none;
  color: #007bff;
  background-color: transparent;
  box-sizing: border-box;
  cursor: pointer;
}

.predictnow {
  width: 200px;
  height: 50px;
}

.span {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  font-size: 1.2rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  text-align: left;
}

h3.w3_head {
  font-weight: 400;
  color: #787878;
  font-size: 1.5em;
  letter-spacing: 0.075em;
  line-height: 1.35em;
  margin-bottom: 3rem !important;
  font-family: inherit;
  margin-top: 0;
  box-sizing: border-box;
  text-align: center;
  display: block;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
}

.popup p {
  font-size: 15px;
  color: #666;
  letter-spacing: .5px;
  line-height: 30px;
  margin: 0;
  display: block;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  box-sizing: border-box;
}

.mt-4 {
  margin-top: 1.5rem !important;
}

.img-fluid {
  max-width: 100%;
  height: auto;
  vertical-align: middle;
  border-style: none;
  box-sizing: border-box;
  visibility: visible;
}

textarea {
  resize: none;
  overflow: auto;
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

.popup #holder {
  height: 50%;
  width: 30%;
  border: 3px dashed gray;
  border-radius: 10px;
  margin: 10px 20px;
  box-sizing: border-box;
  display: block;
  overflow: auto;
  padding: 2px 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/DeepFusion.vue